import type { Network } from 'types/shared';
import datadogActions, { DATADOG_EVENT } from './index';

export const trackNetworkSessionView = (network: Network) => {
  datadogActions.trackDatadogAction(DATADOG_EVENT.networkSessionView, {
    network,
    path: `/networks/${network}`,
  });
};
